//@flow

import env from '../../../environment';
import {
  deleteCreator,
  getCreator,
  postCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  CREATE_SCHEDULED_MESSAGE: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/:conversationId/schedule`,
  LIST_SCHEDULED_MESSAGES: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/scheduled`,
  DELETE_SCHEDULED_MESSAGE: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/schedule/:messageId`,
  EDIT_SCHEDULED_MESSAGE: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/schedule/:messageId`,
});

export const createScheduleMessageApi = postCreator(
  endpoints.CREATE_SCHEDULED_MESSAGE
);

export const editScheduleMessageApi = putCreator(
  endpoints.EDIT_SCHEDULED_MESSAGE
);

export const deleteScheduleMessageApi = deleteCreator(
  endpoints.DELETE_SCHEDULED_MESSAGE
);

export const listScheduledMessagesApi = getCreator(
  endpoints.LIST_SCHEDULED_MESSAGES
);
